import React, { createContext, useContext, useEffect, useRef, useState, useCallback } from "react";
import { wsUrl } from "../lib/api";
import { useAuth } from "./AuthContext";

const WsContext = createContext(null);

export function WsProvider({ children }) {
  const { user } = useAuth();
  const wsRef = useRef(null);
  const subsRef = useRef(new Set());
  const [connected, setConnected] = useState(false);

  const connect = useCallback(() => {
    if (!user) return;
    if (wsRef.current && (wsRef.current.readyState === 0 || wsRef.current.readyState === 1)) return;
    const ws = new WebSocket(wsUrl());
    wsRef.current = ws;
    ws.onopen = () => setConnected(true);
    ws.onclose = () => {
      setConnected(false);
      setTimeout(() => { if (user) connect(); }, 3000);
    };
    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        subsRef.current.forEach((cb) => cb(data));
      } catch (err) {}
    };
  }, [user]);

  useEffect(() => {
    if (user) connect();
    return () => {
      if (wsRef.current) {
        const ws = wsRef.current;
        ws.onclose = null;
        if (ws.readyState === 1) ws.close();
        wsRef.current = null;
      }
    };
  }, [user, connect]);

  const send = useCallback((obj) => {
    if (wsRef.current && wsRef.current.readyState === 1) {
      wsRef.current.send(JSON.stringify(obj));
      return true;
    }
    return false;
  }, []);

  const subscribe = useCallback((cb) => {
    subsRef.current.add(cb);
    return () => subsRef.current.delete(cb);
  }, []);

  return (
    <WsContext.Provider value={{ send, subscribe, connected }}>
      {children}
    </WsContext.Provider>
  );
}

export const useWs = () => useContext(WsContext);
